import { render, staticRenderFns } from "./BatchPayerTypeModal.vue?vue&type=template&id=58f86e7d&scoped=true&"
import script from "./BatchPayerTypeModal.vue?vue&type=script&lang=ts&"
export * from "./BatchPayerTypeModal.vue?vue&type=script&lang=ts&"
import style0 from "./BatchPayerTypeModal.vue?vue&type=style&index=0&id=58f86e7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f86e7d",
  null
  
)

export default component.exports